var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"image__wrapper"},[_c('ImageSpinner',{staticClass:"image__spinner"}),_c('img',{staticClass:"image__item",attrs:{"data-url":_vm.source,"alt":"random image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }